exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit-deliverable-modal.edit-project-modal .field-header {\n  border: unset;\n  background: linear-gradient(to bottom, white 0%, rgba(210, 217, 210, 1) 86%, rgba(203, 211, 203, 1) 100%);\n}\n.edit-deliverable-modal.edit-project-modal .field-box .field-wrap {\n  border: unset;\n}\n", ""]);

// exports
